<template>
  <section>
    <li>
      <label :for="`party${number}ConjugalStatus`">
        <span class="label">What is person {{ number }}'s current conjugal status?</span>
      </label>
      <select
        :id="`party${number}ConjugalStatus`"
        :name="`Party ${number} Conjugal Status`"
        v-model="personDetails.conjugalDetails.conjugalStatus"
      >
        <option selected disabled>- please select -</option>
        <option value="divorcePending">Divorce pending</option>
        <option value="divorced">Divorced</option>
        <option value="neverMarried">Never validly married</option>
        <option value="widowed">Widowed</option>
      </select>
    </li>
    <fieldset v-if="personDetails.conjugalDetails.conjugalStatus != 'neverMarried'">
      <legend>
        <span class="h3">Person {{ number }}'s previous marriage(s)</span>
      </legend>
      <li>
        <label :for="`party${number}PreviousMarriageTerminated`">
          <span class="label">How was the last marriage terminated?</span>
        </label>
        <select
          :id="`party${number}PreviousMarriageTerminated`"
          :name="`Party ${number} Previous Marriage Termination`"
          v-model="personDetails.conjugalDetails.previousMarriageTerminated"
        >
          <option selected disabled>- please select -</option>
          <option value="Death">Death</option>
          <option value="Divorce">Divorce</option>
          <option value="Nullity">Nullity</option>
        </select>
      </li>
      <div 
        v-if="personDetails.conjugalDetails.previousMarriageTerminated != 'Death'"
      >
        <li>
          <label :for="`party${number}PreviousMarriageTerminatedDate`">
            <span class="label">What date did the last marriage end?</span>
            <small class="hint">Date last spouse died, or the date the 
              dissolution of marriage became final or nullity order made.
            </small>
          </label>
          <input
            autocomplete="off"
            class="date-input-max-at-today"
            :id="`party${number}PreviousMarriageTerminatedDate`"
            type="date"
            size="10"
            :name="`Party ${number} Previous Marriage Terminated Date`"
            placeholder="dd/mm/yyyy"
            maxlength="10"
            v-model="personDetails.conjugalDetails.previousMarriageTerminatedDate"
          />
        </li>
        <li v-if="personDetails.conjugalDetails.conjugalStatus != 'widowed'">
          <label
            :id="`party${number}`"
            :for="`party${number}CourtMarriageEnded`"
          >
            <span class="label">Where was the court located for the divorce or nullity?</span>
          </label>

          <input
            autocomplete="off"
            class="autoCompleteAddress stretchWidth"
            :id="`party${number}CourtMarriageEnded`"
            type="text"
            :name="`Party ${number} Court Marriage Ended`"
            maxlength="255"
            role="presentation"
            v-model="personDetails.conjugalDetails.courtMarriageEnded"
          />
        </li>
      </div>
    </fieldset>
  </section>
</template>

<script>
export default {
  props: {
    number: String,
    value: Object,
  },
  computed: {
    personDetails: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
}
</script>